import type { Translations } from "../types";

const ar: Translations = {
  "meta.title": "خريطة النقرات حسب الدولة",
  "meta.description":
    "خريطة عالمية تفاعلية: نقرات مجانية لكل دولة، بالإضافة إلى دعم مدفوع عبر Stripe وPayPal وBuy Me a Coffee.",

  "app.title": "خريطة النقرات حسب الدولة",

  "map.intro":
    "انقر على دولة في الخريطة لمنحها صوتًا مجانيًا، أو أرسل لها دعمًا ماليًا - يُحتسب كلاهما ضمن لوحة الصدارة المجمّعة أدناه. تعكس الخريطة فقط الدعم داخل هذا التطبيق، وليس الثروة الوطنية الفعلية أو الناتج المحلي الإجمالي.",
  "map.verifying": "جارٍ التحقق …",
  "map.confirmNotRobot": "قبل إضافة نقرات مجانية، يُرجى تأكيد أنك لست روبوتًا:",
  "map.tryAgain": "أعد المحاولة",
  "map.registeringClick": "جارٍ تسجيل النقرة …",
  "map.selectedCountry": "الدولة المحددة: {name}.",
  "map.selectFirstFeedback": "تم اختيار الدولة. لإضافة نقرة مجانية، أكّد أولاً أدناه أنك لست روبوتًا.",
  "map.verificationExpired": "انتهت صلاحية التحقق - أكّد مجددًا أنك لست روبوتًا.",
  "map.slowDown": "تمهّل قليلاً - انتظر لحظة قبل النقرة التالية.",
  "map.clickFailed": "تعذّر تسجيل النقرة. يُرجى المحاولة مرة أخرى.",
  "map.clickErrorGeneric": "حدث خطأ أثناء تسجيل النقرة.",
  "map.leaderboardHeading": "لوحة صدارة الدول",
  "map.emptySelection": "اختر دولة على الخريطة للنقر عليها أو دعمها.",
  "map.loadingData": "جارٍ تحميل البيانات …",

  "worldmap.loadError": "تعذّر تحميل الخريطة.",
  "worldmap.resetZoom": "إعادة ضبط التكبير",
  "worldmap.resetButton": "⤾ إعادة ضبط",
  "worldmap.loadingMap": "جارٍ تحميل الخريطة …",
  "worldmap.unknownCountry": "غير معروف",
  "worldmap.ariaClicks": "{name}: {clicks} نقرة",
  "worldmap.tooltipClicks": "{clicks} نقرة",

  "legend.fewer": "نقرات أقل",
  "legend.more": "نقرات أكثر",

  "list.empty": "لا توجد نقرات بعد. كن الأول!",
  "list.ariaLabel": "لوحة صدارة الدول حسب عدد النقرات",

  "human.siteKeyMissing": "لم يتم ضبط VITE_TURNSTILE_SITE_KEY - راجع ملف README للإعداد.",
  "human.verificationFailedGeneric": "فشل التحقق.",
  "human.networkError":
    "تعذّر الوصول إلى خدمة التحقق (خطأ في الشبكة) - تحقق من VITE_SUPABASE_URL، ومن نشر verify-human، ومن ALLOWED_ORIGIN؛ راجع README/NAVODILA.",
  "human.verificationFailedRetry": "فشل التحقق، حاول مرة أخرى.",

  "provider.stripe": "💳 بطاقة (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "الدولة المحددة",
  "panel.currentlyRanked": "الترتيب الحالي #{rank}",
  "panel.shareCopied": "تم النسخ ✓",
  "panel.shareShared": "تمت المشاركة ✓",
  "panel.shareButton": "🔗 مشاركة",

  "panel.tableClicks": "النقرات",
  "panel.tableFree": "مجاني",
  "panel.tablePaid": "مدفوع",
  "panel.rowAllTime": "منذ البداية",
  "panel.rowThisYear": "هذا العام",
  "panel.rowThisWeek": "هذا الأسبوع",
  "panel.rowToday": "اليوم",

  "panel.totalCombined": "الإجمالي المجمّع:",
  "panel.totalSupport": "إجمالي الدعم:",

  "panel.paymentMethod": "طريقة الدفع",
  "panel.noPaymentMethod": "لا توجد حاليًا أي طريقة دفع متاحة.",
  "panel.supportAmount": "مبلغ الدعم (يورو)",
  "panel.amountRange": "يجب أن يكون المبلغ بين {min} و{max}.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "النقرات المدفوعة المقدّرة:",
  "panel.ratioInfo":
    "النسبة: {a} = {b} نقرة (مثال: {c} = {d} نقرة). هذا مجرد تقدير قبل الدفع - يتم دائمًا احتساب عدد النقرات النهائي وتأكيده من قبل الخادم بناءً على الدفع المؤكد فعليًا.",
  "panel.preparing": "جارٍ التحضير …",
  "panel.continueWith": "المتابعة عبر {provider}",
  "panel.choosePaymentMethod": "اختر طريقة الدفع",
  "panel.bmcUsernameMissing": "لم يتم ضبط VITE_BMC_USERNAME - راجع ملف README للإعداد.",
  "panel.paypalClientIdMissing": "لم يتم ضبط VITE_PAYPAL_CLIENT_ID - راجع ملف README للإعداد.",

  "panel.paypalAmountInfo": "المبلغ: {amount} (تقديريًا {clicks} نقرة). أكمل الدفع عبر زر PayPal أدناه.",
  "panel.back": "← رجوع",

  "panel.bmcWarningTitle": "⚠️ قبل المتابعة إلى BuyMeCoffee:",
  "panel.bmcWarningBody":
    "الصق الرمز أدناه في حقل الرسالة/الملاحظة عند الدفع — فهذه هي الطريقة الوحيدة التي نعرف بها الدولة التي تدعمها. بدون الرمز، لا يمكننا نسب الدفعة إلى أي دولة.",
  "panel.copy": "نسخ",
  "panel.copied": "تم النسخ ✓",
  "panel.suggestedAmount": "المبلغ المقترح:",
  "panel.bmcAmountNote":
    "(تقديريًا {clicks} نقرة). للأسف لا يدعم BuyMeCoffee نقل المبلغ عبر الرابط — أدخل المبلغ أو اخترْه بنفسك على موقعهم. يُحتسب عدد النقرات الفعلي دائمًا بناءً على المبلغ الذي ترسله فعليًا على BuyMeCoffee، وليس بناءً على هذا التقدير.",
  "panel.openBmc": "افتح BuyMeCoffee وتابع →",
  "panel.waitingProvider": "بانتظار تأكيد الدفع من مزوّد الدفع …",
  "panel.waitingConfirmation": "بانتظار تأكيد الدفع …",
  "panel.timedOut":
    "انتهت مهلة التحقق. إذا أتممت الدفع، فستتحدّث الخريطة فور استلام الخادم للتأكيد - قد يستغرق هذا أحيانًا وقتًا أطول قليلاً.",
  "panel.checkAgain": "تحقق مرة أخرى",

  "panel.cancelled": "تم إلغاء الدفع أو لم يكتمل. لم تتغيّر الخريطة.",
  "panel.tryAgain": "أعد المحاولة",

  "panel.confirmed": "✅ تم تأكيد الدعم!",
  "panel.confirmedBody": "حصلت {country} على {clicks} نقرة مدفوعة مقابل {amount}.",

  "panel.errorPreparingSupport": "حدث خطأ أثناء تحضير دعمك.",
  "panel.errorPreparingPayment": "حدث خطأ أثناء تحضير الدفع.",
  "panel.errorConfirmingPayment": "حدث خطأ أثناء تأكيد الدفع.",
  "panel.errorPayingPaypal": "حدث خطأ أثناء الدفع عبر PayPal.",

  "share.unranked": "{flag}{country} بحاجة إلى دعمك على خريطة العالم!\nساعدها على التقدّم في لوحة الصدارة 👇",
  "share.rank1": "{flag}{country} تحتل حاليًا المركز الأول!\nساعدنا على البقاء في القمة 👇",
  "share.rankN": "{flag}{country} تحتل حاليًا المركز #{rank}!\nساعدنا على الوصول إلى المركز الأول 👇",

  "language.switcherLabel": "اللغة",
};

export default ar;
